
            const data = {"name":"chevron","data":{"width":"12","height":"7","viewBox":"0 0 12 7","data":"<path pid=\"0\" d=\"M10.667 1 6 5.667 1.333 1\" _stroke=\"#000\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#000"}],"stopColors":[]}}
        
                    module.exports = data
                    